var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100mm",
    height: "100mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 10000 10000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ae0d12",
    d: "M9642.3 9046.17c-175.57,-116.46 -282.17,-203.25 -320.18,-260.49 -71.18,-102.15 -241.91,-528.17 -512.26,-1278.1 -270.41,-749.96 -536.06,-1429.35 -796.89,-2038.32 -659.3,-1503.86 -1277.1,-2728.88 -1853.41,-3674.96 -532.77,-874.4 -923.1,-1410.64 -1163.37,-1410.64 -240.17,0 -630.64,536.24 -1163.27,1410.64 -576.31,946.08 -1194.11,2171.1 -1853.51,3674.96 -260.73,608.97 -526.53,1288.36 -796.88,2038.32 -270.39,749.93 -441.13,1175.95 -512.32,1278.1 -37.86,57.24 -144.55,144.03 -320.17,260.49 -175.34,116.45 -263.22,234.04 -263.22,352.46 0,89.99 54.61,152.39 163.61,186.98 31.2,9.94 70.94,18.48 119.22,25.61 280.87,41.24 568.11,-19.28 807.29,-161.02 545.12,-322.99 1855.91,-786.47 3819.25,-786.47 1961.56,0 3271.78,462.25 3817.79,785.58 249.89,147.89 551.68,208 843.43,156.34 32.93,-5.92 61.18,-12.58 84.5,-20.04 108.99,-34.59 163.65,-96.99 163.65,-186.98 0,-118.42 -87.79,-236.01 -263.26,-352.46zm-4687.16 -1364c0,46.09 -40.5,83.19 -90.56,83.75 -1182.27,12.49 -2203.9,267.97 -2576.49,387.7 -71.5,22.99 -136.63,-39.08 -116.03,-106.18 1343.08,-4361.72 2783.08,-6597.96 2783.08,-6597.96l0 6232.69z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0eebb6c0831c6c67c04fef611081904d.svg";
export { ForwardRef as ReactComponent };